import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './admin.css';

const navClass = ({ isActive }) => `adm-nav-link${isActive ? ' is-active' : ''}`;

export default function AdminLayout() {
  const { username, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login', { replace: true });
  };

  const initial = (username || 'A').charAt(0).toUpperCase();

  return (
    <div className="adm adm-shell">
      <aside className="adm-sidebar">
        <div className="adm-brand">
          <span className="adm-brand-mark">S</span>
          <div>
            <div className="adm-brand-name">SSSMIL</div>
            <div className="adm-brand-sub">Admin Portal</div>
          </div>
        </div>

        <nav className="adm-nav" aria-label="Admin navigation">
          <NavLink to="/admin" end className={navClass}>
            <i className="bi bi-grid-1x2" />
            <span>Dashboard</span>
          </NavLink>
          <NavLink to="/admin/documents" className={navClass}>
            <i className="bi bi-file-earmark-pdf" />
            <span>Documents</span>
          </NavLink>
          <a
            className="adm-nav-link adm-nav-ext"
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            title="View website"
            aria-label="View website"
          >
            <i className="bi bi-box-arrow-up-right" />
            <span>View website</span>
          </a>
        </nav>

        <div className="adm-sidebar-foot">
          <div className="adm-user">
            <span className="adm-avatar">{initial}</span>
            <span className="adm-user-name">{username}</span>
          </div>
          <button type="button" className="adm-btn adm-btn-ghost" onClick={handleLogout}>
            <i className="bi bi-box-arrow-right" />
            Log out
          </button>
        </div>
      </aside>

      <main className="adm-main">
        <div className="adm-container">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
